import IconAppleStore from '../static/IconAppleStore.svg';
import IconGoogleStore from '../static/IconGoogleStore.svg';
import IconHuaweiStore from '../static/IconHuaweiStore.svg';
import IconRuStore from '../static/IconRuStore.svg';

const appStores = {
    appStore: {
        name: 'App Store',
        icon: IconAppleStore,
        href: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/appstore/?placement=ios_footer_install',
    },
    googlePlay: {
        name: 'Google Play',
        icon: IconGoogleStore,
        href: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/googleplay/?placement=android_footer_install',
    },
    huaweiAppGallery: {
        name: 'HUAWEI AppGallery',
        icon: IconHuaweiStore,
        href: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/huaweiAppGallery/?placement=huaweiappgallery_footer_install',
    },
    ruStore: {
        name: 'RuStore',
        icon: IconRuStore,
        href: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/rustore/?placement=rustore_footer_install',
    },
};

export { appStores };
//# sourceMappingURL=appStores.js.map
